import * as converter from './converter';
import * as googlePlace from './googlePlace';
import * as customHook from './customHook';
import * as mapTools from './mapTools';
import * as propertyParser from './propertyParser';

const Utils = { ...converter, ...googlePlace, ...customHook, ...mapTools, ...propertyParser };

export default Utils;
